import { render, staticRenderFns } from "./MyCompensation.vue?vue&type=template&id=66868282&scoped=true"
import script from "./MyCompensation.vue?vue&type=script&lang=js"
export * from "./MyCompensation.vue?vue&type=script&lang=js"
import style0 from "./MyCompensation.vue?vue&type=style&index=0&id=66868282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66868282",
  null
  
)

export default component.exports